/* eslint-disable class-methods-use-this */
import axios from "axios";

class ApiSettings {
  constructor(params) {
    this.defaultPayloadParams = params;
    this.baseApi = null;
    this.slug = null;
  }

  initAPI(settings) {
    this.setDefaultAxiosSettings(settings.searchBaseUrl);
    this.setDefaultPayloadParams(settings);
    this.setBaseApi(settings.searchApiUrl);
    this.setSlug(settings.searchPageSlug);
  }

  setBaseApi(api) {
    this.baseApi = api;
  }

  setSlug(slug) {
    this.slug = slug;
  }

  setDefaultAxiosSettings(baseURL) {
    axios.defaults.baseURL = baseURL;
    // axios.defaults.headers.common.Authorization = "Basic c25hY2t0ZW1wbGU6OXNOdCBTT1FEIFdaQzQgNVlJZSBMbWdBIGZKdm0=";
  }

  setDefaultPayloadParams(settings) {
    this.defaultPayloadParams = settings;
  }
}

const apiSettings = new ApiSettings();
export default apiSettings;
